export default __webpack_public_path__ + "static/img/keyboard-confirm@2x.a7771b.png";